module.exports = __webpack_public_path__ + "img/WP2023-Icon-FS.e800b142.svg";